/** @format */

export const ages = [
  '<15 yrs',
  '15-24 yrs',
  '25-40 yrs',
  '40-60 yrs',
  '>60yrs',
];

export const genders = ['Male', 'Female'];

export const relations = ['Family', 'Friend'];

export const ocassions = ['Birthday', 'Holidays(Festivals, etc)'];

export const interests1 = [
  'Sports',
  'Arts',
  'Gaming',
  'Music',
  'Cooking',
  'Reading',
  'Fashion',
  'TV',
];

export const interests2 = [
  [
    'Football',
    'Basketball',
    'Hockey',
    'Cricket',
    'Badminton',
    'Athletics',
    'Tennis',
    'Indoor',
    'Volleyball',
    'Boxing',
    'Skating',
    'Rugby',
    'Cycling',
    'Fishing',
  ],
  ['Painting', 'Spray Painting', 'Doodle'],
  ['PC', 'Console', 'Mobile'],
  ['Classical', 'Western', 'Electronic'],
  ['Baking', 'Utilities', 'General'],
  ['Horror', 'Sci-fi', 'Non fiction', 'Drama/Thriller'],
  ['Apparel', 'Accessories', 'Jewellery', 'Cosmetics', 'Footwear'],
  ['Anime', 'Thriller', 'Non-fiction', 'Sitcom', 'Fantasy'],
];

export const budgets = ['Not that costly', 'Moderate', 'Can be expensive!'];

export const indexes = [0, 14, 17, 20, 23, 26, 30, 35];
